<template>
  <main class="edition-item" :key="edition.uid">
    <div class="project" ref="project" :key="edition.uid">
      <div class="title" :class="{ show: show }">
        {{ edition.title }}
      </div>
      <div class="images">
        <img v-for="img in edition.files" :key="img.id" v-lazy="img.url" />
      </div>
      <div class="description" :class="{ show: show }">
        {{ edition.caption }}<br />
        <div
          class="desc"
          v-if="edition.description"
          v-html="edition.description"
        ></div>
        <div class="">
          <br />
          <span v-if="edition.request">
            {{ edition.price }}€<a
            class="request"
            target="_blank"
            :href="
              'mailto:order@estellebourdet.com?subject=' +
                edition.title +
                '&body=' +
                msg
            "
            >, BUY</a
          ></span>
          <span v-else>SOLD</span>
        </div>
      </div>
    </div>
    <editions />
  </main>
</template>

<script>
import Editions from "@/components/Editions";
export default {
  components: {
    Editions
  },
  props: {
    id: String
  },
  data() {
    return {
      show: true,
      msg:
        "Hello,%0A%0AI am interested about the weaving named above and would be pleased to receive further information on payment and delivery. Please find my details below.%0A%0AName: (First Name, Last Name)%0AAddress: (Street, City, Postal code, Country)%0APhone:%0A%0AI am looking forward to hear from you.%0ABest wishes%0A"
    };
  },
  computed: {
    editions() {
      return this.$store.state.editions;
    },
    edition() {
      let editions = this.editions;
      const result = editions.filter(edition => edition.uid == this.id);
      return result[0];
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let breakpoint =
        this.$refs.project.clientHeight - window.outerHeight / 1.5;
      if (window.scrollY > breakpoint && window.outerWidth > 768) {
        this.show = false;
      } else {
        this.show = true;
        // this.$refs.description.style.opacity = 1;
      }
    }
  },
  metaInfo() {
    return {
      title: "– " + this.edition.title
    };
  }
};
</script>

<style lang="scss" scoped>
.edition-item {
  text-align: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
  .project {
    box-sizing: border-box;
    width: 100%;
    padding: 0 1em;
    position: relative;
    .title {
      position: fixed;
      top: 5em;
      left: 1em;
      transition: opacity 0.5s;
      opacity: 0;
      &.show {
        opacity: 1;
      }
    }
    .buy {
      position: fixed;
      bottom: 0;
      right: 0;
      padding: 1em;
      transition: opacity 0.5s;
      opacity: 0;
      &.show {
        opacity: 1;
      }
    }
    .description {
      position: fixed;
      bottom: 0;
      width: calc(100% - 1em);
      left: 0;
      padding: 1em;
      transition: opacity 0.5s;
      opacity: 0;
      text-align: left;
      &.show {
        opacity: 1;
      }
      .desc {
        width: 50%;
      }
      @media only screen and (max-width: 768px) {
        width: 100%;
        position: relative;
        padding: 0;
        .desc {
          width: 100%;
        }
      }
      .request {
        // position: absolute;
        // right:0;
        // bottom:0;
        // padding:0.5em;
        span {
          position: relative;
          display: inline-block;
          transition: transform 0.2s;
        }
        &:hover {
          span {
            &:nth-of-type(1) {
              transform: translate(0, -0.7rem);
            }
            &:nth-of-type(2) {
              transform: translate(0, -0.3rem);
            }
            &:nth-of-type(4) {
              transform: translate(0, -0.5rem);
            }
            &:nth-of-type(6) {
              transform: translate(0, -0.75rem);
            }
            &:nth-of-type(7) {
              transform: translate(0, -1rem);
            }
            &:nth-of-type(9) {
              transform: translate(0, -0.32rem);
            }
            &:nth-of-type(11) {
              transform: translate(0, -1rem);
            }
            &:nth-of-type(13) {
              transform: translate(0, -0.75rem);
            }
            &:nth-of-type(15) {
              transform: translate(0, -0.75rem);
            }
            &:nth-of-type(18) {
              transform: translate(0, -0.75rem);
            }
          }
        }
        @media only screen and (max-width: 768px) {
          padding: 0;
          margin-top: 1em;
          position: relative;
          display: block;
          &:hover {
            span {
              &:nth-of-type(2) {
                transform: translate(0, 1rem);
              }
              &:nth-of-type(4) {
                transform: translate(0, 1.5rem);
              }
              &:nth-of-type(6) {
                transform: translate(0, 0.75rem);
              }
              &:nth-of-type(9) {
                transform: translate(0, 1rem);
              }
              &:nth-of-type(11) {
                transform: translate(0, 1.5rem);
              }
              &:nth-of-type(13) {
                transform: translate(0, 0.75rem);
              }
              &:nth-of-type(15) {
                transform: translate(0, 0.75rem);
              }
              &:nth-of-type(18) {
                transform: translate(0, 0.75rem);
              }
            }
          }
        }
      }
    }
    .images {
      margin-bottom: 200px;
      @media only screen and (max-width: 768px) {
        margin-bottom: 0;
      }
      // font-size:0;
    }
    img {
      width: 100%;
      max-width: 100%;
      max-height: calc(100vh - 10em);
      @media only screen and (max-width: 768px) {
        max-height: none;
      }
      padding-bottom: 1em;
      display: block;
      object-fit: contain;
      object-position: center;
    }
  }
}
</style>
